import React, { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import ThankYou from "@/components/landing/ThankYou";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";

function ThankYouPage() {
  const [lead, setLead] = useState<any>(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("leadData");
      if (raw) {
        setLead(JSON.parse(raw));
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header onCta={() => document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" })} />
      <main>
        <ThankYou
          lead={lead}
          onClose={() => {
            try {
              sessionStorage.removeItem("leadData");
            } catch {}
            window.location.href = "/";
          }}
        />
      </main>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/thank-you")({
  component: ThankYouPage,
});
